<template>
  <div>
    <ChangeMobileMoneyCode />
  </div>
</template>

<script>
import ChangeMobileMoneyCode from "./ChangeCodeMomo.vue";

export default {
  name: "SimCardComponents",
  components: {
    ChangeMobileMoneyCode,
  },
};
</script>